/**
 * Cupón de vendedor que el cliente escribió en el carrito. Se guarda en el
 * navegador para que siga aplicado si vuelve más tarde a terminar la compra.
 */
import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'onfase_cupon';

let actual: string | null = leer();
const oyentes = new Set<() => void>();

function leer(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setCupon(codigo: string | null): void {
  actual = codigo ? codigo.trim().toUpperCase() : null;
  try {
    if (actual) localStorage.setItem(STORAGE_KEY, actual);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Sin almacenamiento (modo privado): vale para esta visita
  }
  oyentes.forEach((fn) => fn());
}

export function useCuponGuardado(): string | null {
  return useSyncExternalStore(
    (fn) => {
      oyentes.add(fn);
      return () => oyentes.delete(fn);
    },
    () => actual,
  );
}
